import { request } from "../lib/requestHelper";

export const checkArtisanBookingStatusService = async (artisanId) => {
    return await request(`user/check-artisan-booking-status/${artisanId}`, { method: "GET" });
};